import { createFileRoute } from "@tanstack/react-router";

import { PagePlaceholder } from "@/components/page-placeholder";

export const Route = createFileRoute("/_authed/_dashboard/inbox")({
  component: InboxPage,
});

function InboxPage() {
  return <PagePlaceholder title="Inbox" phase="P2 — Inbox + tasks" />;
}
